module.exports = __webpack_public_path__ + "static/media/781c5453-0067-4e64-9386-7c0726d63d57.2052e5a6.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/1274151/781c5453-0067-4e64-9386-7c0726d63d57.woff2
// module id = 1665
// module chunks = 2